var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import LoaderCard from '@/components/loader-card/LoaderCard';
import { Subject } from '@/models/Subject';
import ErrorHandler from '@/support/ErrorHandler';
import CreateTermDialog from '@/components/create-term-dialog/CreateTermDialog.vue';
import { LvsPeriod } from '@/models/LvsPeriod';
import { LvsSubjectSetting } from '@/models/LvsSubjectSetting';
let SchoolLvsSettings = class SchoolLvsSettings extends Vue {
    constructor() {
        super(...arguments);
        this.areas = [];
        this.isAddingTerm = false;
        this.isLoading = false;
        this.isUpdatingArea = false;
        this.isUpdatingPeriod = false;
        this.isLoadingPeriods = false;
        this.isLoadingAreas = false;
        this.lvsPeriods = [];
    }
    async updateLvsPeriod(periodId) {
        const periodToUpdate = this.lvsPeriods.find(((period) => period.id === periodId));
        if (!periodToUpdate) {
            return;
        }
        this.isUpdatingPeriod = true;
        try {
            await periodToUpdate.put({
                is_active: periodToUpdate.is_active,
            });
        }
        catch (error) {
            ErrorHandler.network(error);
        }
        this.isUpdatingPeriod = false;
    }
    async mounted() {
        this.isLoading = true;
        this.fetchLvsPeriods();
        await this.fetchAreas();
        this.patchAreas();
        this.isLoading = false;
        this.isLoadingPeriods = false;
        this.isLoadingAreas = false;
    }
    async fetchAreas() {
        this.isLoadingAreas = true;
        await new Subject()
            .include('lvs_subject_setting')
            .all()
            .then((areas) => {
            this.areas = areas;
            this.isLoadingAreas = false;
        }).catch(() => { this.isLoadingAreas = false; });
    }
    patchAreas() {
        this.areas.forEach((area) => {
            if (!(area.lvs_subject_setting)) {
                area.lvs_subject_setting = {
                    is_active: false,
                };
            }
        });
    }
    fetchLvsPeriods() {
        this.isLoadingPeriods = true;
        new LvsPeriod()
            .all()
            .then((periods) => {
            this.lvsPeriods = periods;
            this.isLoadingPeriods = false;
        }).catch(() => {
            this.isLoadingPeriods = false;
        });
    }
    // FIXME need api
    async updateLvsArea(areaId) {
        const areaToUpdate = this.areas
            .find(((area) => area.id === areaId));
        if (!areaToUpdate) {
            return;
        }
        this.isUpdatingArea = true;
        const isActive = areaToUpdate && areaToUpdate.lvs_subject_setting && areaToUpdate.lvs_subject_setting.is_active;
        await new LvsSubjectSetting()
            .create({
            subject_id: areaToUpdate.id,
            is_active: isActive,
        })
            .catch((error) => ErrorHandler.network(error));
        this.isUpdatingArea = false;
    }
};
SchoolLvsSettings = __decorate([
    Component({
        components: {
            LoaderCard,
            CreateTermDialog,
        },
    })
], SchoolLvsSettings);
export default SchoolLvsSettings;
